import * as Yup from 'yup';

export const contactEmploymentValidationSchema = Yup.object().shape({
  monthsAtJob: Yup.number().nullable(),
  jobTitle: Yup.string().nullable().required('Position is required').max(26, 'Position should be max 26 symbols'),
  employmentType: Yup.string().nullable(),
  companyName: Yup.string().required().nullable().max(26, 'Company should be max 26 symbols'),
  monthlyIncomeAmount: Yup.number().nullable(),
  isCurrent: Yup.boolean().nullable(),
  isPrimary: Yup.boolean().nullable(),
  streetLine1: Yup.string().nullable().max(128, 'Street should be max 128 symbols'),
  streetLine2: Yup.string().nullable(),
  unit: Yup.string().nullable().max(128, 'Unit should be max 128 symbols'),
  phone: Yup.string().phone().nullable(),
  state: Yup.string().nullable(),
  zip: Yup.string().zipCode().nullable(),
  city: Yup.string().nullable().max(128, 'City should be max 128 characters'),
  type: Yup.string().nullable(),
  county: Yup.string().nullable(),
});
